import { usePrefetchPendingExperiences } from "@src/api/experiences/use-prefetch-pending-experiences";

export const usePrefetchPendingPersonalizations = async () => {
  void usePrefetchPendingExperiences("personalization");
};
